import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import TagForm from '../TagForm/TagForm';
import { TAG_FORM_DEFAULT_VALUES } from '../TagForm/constants';
import { useModals } from 'hooks/useModals';
import { TTagsEdit } from './TagsEdit.types';
import { useAppDispatch } from 'store/store';
import { TTagFormValues } from '../TagForm/TagForm.types';
import {
  getTagsListAsyncThunk,
  updateTagAsyncThunk,
} from 'store/tags/tags.action';

const TagsEdit: TTagsEdit = ({ item }) => {
  const dispatch = useAppDispatch();
  const modals = useModals();

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { ...TAG_FORM_DEFAULT_VALUES, ...item },
  });

  const handleSubmit = (data: TTagFormValues) => {
    dispatch(
      updateTagAsyncThunk({
        id: item.id,
        body: { ...data, id: item.id },
        onSuccess: () => {
          modals.closeModal();
          dispatch(getTagsListAsyncThunk());
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <TagForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default TagsEdit;
